import React, { Component } from 'react'
import { Route, Redirect, Switch, withRouter } from 'react-router'
import { connect } from 'react-redux'
import { equals } from 'ramda'
import PropTypes from 'prop-types'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
import { MainRoute, ParentRoute } from '../Components/CustomRoutes'
import Layout from './Layout'
import ParentLayout from './ParentPlatform/ParentLayout'
import Center from './Center/Center'
import Attendance from './Reports/AttendanceReports'
import Kids from './Reports/KidsReports'
import Finances from './Reports/FinancesReports'
import Incidents from './Reports/IncidentsReports'
import Enrollment from './Reports/EnrollmentReports'
import Disenrollment from './Reports/DisenrollmentReports'
import MasterList from './Reports/MasterListReports'
import Receipt from './Reports/ReceiptReports'
import UnvalidatedReceiptsReports from './Reports/UnvalidatedReceiptsReports'
import DomiciliationReports from './Reports/DomiciliationReports'
import Ratings from './Reports/RatingsReports'
import ReportsBi from './Reports/ReportsBi'
import MedalliaReport from './Reports/MedalliaReport'
import Dashboard from './Dashboard'
import DirectorView from './Dashboard/DirectorView'
import CentersInfo from './Dashboard/CentersInfo'
import VirtualCheckin from './VirtualCheckin/VirtualCheckin'
import StudentProfile from './StudentProfile/StudentProfile'
import Inscriptions from './Inscriptions/Inscriptions'
import Reinscriptions from './Inscriptions/Reinscriptions'
import Reservations from './Inscriptions/Reservations'
import Unsubscribe from './Inscriptions/Unsubscribe'
import PaymentReminders from './PaymentReminders/PaymentReminders'
import Parent from './ParentPlatform'
import Medicine from './Medicine'
import Balance from './ParentPlatform/Balance'
import AdvancedSearch from './AdvancedSearch'
import UnvalidatedPhotos from './PhotoValidations/UnvalidatedPhotos'
import UnvalidatedReceipts from './ReceiptValidations/UnvalidatedReceipts'
import ValidatedReceipts from './ReceiptValidations/ValidatedReceipts'
import VideoGenerator from './VideoGenerator/VideoGenerator'
import VideoList from './VideoGenerator/VideoList'
import ReservationsBmx from './ReservationBMX'
import ReservationsB2B from './ReservationB2B'
import CreateProfile from './Courses/CreateProfile'
import CoursesInfo from './Courses/CoursesInfo'
import TestQr from './TestQr/TestQr'
import ServiceOccasional from './ServiceOccasional'
import NewServiceOccasional from './ServiceOccasional/NewServiceOccasional'
import DocumentLibrary from './Documents/DocumentLibrary'
import DocumentDetail from './Documents/DocumentDetail'
/*-------------All Redux-----------------*/
import ConsumbalesActions from '../Data/Redux/ConsumablesRedux'
import ConsumbalesCategoriesActions from '../Data/Redux/ConsumablesCategoriesRedux'
import NotificationsActions from '../Data/Redux/NotificationsRedux'
import StudyProgramsActions from '../Data/Redux/StudyProgramsRedux'
import InventoryActions from '../Data/Redux/InventoryRedux'
import HealthCheckActions from '../Data/Redux/HealthCheckRedux'
import CompaniesActions from '../Data/Redux/CompaniesRedux'
import RelationsActions from '../Data/Redux/RelationsRedux'
import CenterOptionsActions from '../Data/Redux/CenterOptionsRedux'
import ParentPaymentTypesActions from '../Data/Redux/ParentPaymentTypesRedux'
import PaymentTypesMsiActions from '../Data/Redux/PaymentTypesMsiRedux'
import CountriesActions from '../Data/Redux/CountriesRedux'
import EmergencyMedicationsActions from '../Data/Redux/EmergencyMedications'
import MoodActions from '../Data/Redux/Mood'
import IncidentTypesActions from '../Data/Redux/IncidentTypes'
import ProgramLevelsActions from '../Data/Redux/ProgramLevelsRedux'
import ClassroomActions from '../Data/Redux/ClassroomRedux'
import RegimenFiscalActions from '../Data/Redux/RegimenFiscalRedux'
import UsoCFDIActions from '../Data/Redux/UsoCFDIRedux'
import { stringContainsAnyOf } from '../utils/Utils'

const CenterRoute = ({ match }) => <Layout match={match} activity slot={<Center />} />
const InscriptionsRoute = ({ match }) => <Layout match={match} slot={<Inscriptions />} />
const ReinscriptionsRoute = ({ match }) => <Layout match={match} slot={<Reinscriptions />} />
const ReservationsRoute = ({ match }) => <Layout match={match} slot={<Reservations />} />

const UnsubscribeRoute = ({ match }) => <Layout match={match} slot={<Unsubscribe />} />
const VirtualCheckinRoute = ({ match }) => <Layout match={match} slot={<VirtualCheckin />} />
const StudentProfileRoute = ({ match }) =>
  <Layout match={match} activity slot={<StudentProfile match={match} />} />
const PaymentRemindersRoute = ({ match, location }) => <Layout match={match} slot={<PaymentReminders match={match} location={location} />} />
const ParentPlatformRoute = ({ match }) => <ParentLayout slot={<Parent match={match} />} />
const BalanceRoute = ({ match }) => <ParentLayout slot={<Balance match={match} />} />
const MedicineRoute = ({ match, location }) => <Layout match={match} slot={<Medicine match={match} location={location} />} />
const AttendanceRoute = ({ match }) => <Layout match={match} slot={<Attendance />} />
const KidsRoute = () => <Layout slot={<Kids />} />
const FinancesRoute = ({ match }) => <Layout match={match} slot={<Finances />} />
const RatingsRoute = ({ match }) => <Layout match={match} slot={<Ratings />} />
const IncidentsRoute = ({ match }) => <Layout match={match} slot={<Incidents />} />
const EnrollmentRoute = ({ match }) => <Layout match={match} slot={<Enrollment />} />
const DisenrollmentRoute = ({ match }) => <Layout match={match} slot={<Disenrollment />} />
const MasterListRoute = ({ match }) => <Layout match={match} slot={<MasterList />} />
const ReceiptRoute = ({ match }) => <Layout match={match} slot={<Receipt />} />
const UnvalidatedReceiptsReportRoute = ({ match }) => <Layout match={match} slot={<UnvalidatedReceiptsReports />} />
const DomiciliationReportRoute = ({ match }) => <Layout match={match} slot={<DomiciliationReports match={match} />} />
const DashboardRoute = ({ match }) => <Layout match={match} slot={<Dashboard />} />
const DirectorDashboardRoute = ({ match }) => <Layout match={match} slot={<DirectorView />} />
const UnvalidatedPhotosRoute = () => <Layout slot={<UnvalidatedPhotos />} />
const UnvalidatedReceiptsRoute = ({ match, location }) =>
  <Layout match={match} slot={<UnvalidatedReceipts match={match} location={location} />} />
const ValidatedReceiptsRoute = ({ match, location }) =>
  <Layout match={match} slot={<ValidatedReceipts match={match} location={location} />} />
const OverviewRoute = ({ match, location }) => <Layout match={match} slot={<CentersInfo match={match} location={location} />} />
const AdvancedSearchRoute = ({ match, location }) => <Layout match={match} slot={<AdvancedSearch match={match} location={location} />} />
const VideoGeneratorRoute = ({ match }) => <Layout match={match} slot={<VideoGenerator />} />
const VideoListRoute = ({ match }) => <Layout match={match} slot={<VideoList />} />
const ReservationsBmxRoute = ({ match }) => <Layout match={match} slot={<ReservationsBmx />} />
const ReservationsB2BRoute = ({ match }) => <Layout match={match} slot={<ReservationsB2B />} />
const ReportsBiRoute = ({ match }) => <Layout match={match} slot={<ReportsBi />} />
const MedalliaReportRoute = ({ match }) => <Layout match={match} slot={<MedalliaReport />} />
const CreateProfileRoute = ({ match }) => <Layout match={match} slot={<CreateProfile />} />
const CreateInfoRoute = ({ match }) => <Layout match={match} slot={<CoursesInfo />} />
const TestQrRoute = ({ match }) => <Layout match={match} slot={<TestQr />} />
const ServiceOccasionalRoute = ({ match }) => <Layout match={match} slot={<ServiceOccasional />} />
const NewServiceOccasionalRoute = ({ match }) => <Layout match={match} slot={<NewServiceOccasional />} />
const DocumentLibraryRoute = ({ match }) => <Layout match={match} slot={<DocumentLibrary />} />
const DocumentDetailRoute = ({ match }) => <Layout match={match} slot={<DocumentDetail match={match} />} />
const notifyCheckout = (msg,type) => toast(msg,{icon: ({theme, type}) =>  <img src="/assets/BabyAvatar.svg"/>,type,});

const mainComponent = {
  director: DirectorDashboardRoute,
  back_office: DashboardRoute,
  default: CenterRoute,
}

class AppContainer extends Component {
  componentWillMount = () => {
    const {
      user,
      getCenterOptions,
      getRegimenFiscal,
      getUsoCFDI,
    } = this.props
    if (user && stringContainsAnyOf(user.role, ['Back Office', 'Director','Receptionist'])) {
      getCenterOptions()
    }
    getRegimenFiscal()
    getUsoCFDI()

    this.fetchDataBasedOnUserType()

    // if (!window.location.hostname.includes('miadvenio.com')) {
    //   alert('¡Esta es la página de pruebas! Asegúranse de utilizar la plataforma oficial: http://app.miadvenio.com/')
    // }
    isSupported().then(response => {
      if (response){
        const messaging = getMessaging();
        onMessage(messaging, (payload) => {
          const { data = {}, notification = {} } = payload
          const { child_id, classroom_id, action } = data
          const body = notification.body || data.body
          const type = action === 'save' ? 'info' : 'warning'

          if (body) {
            notifyCheckout(body, type)
          }

          if (child_id && classroom_id && action) {
            this.props.setCheckout(child_id, classroom_id, action)
          }
        });
      }
    })
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (equals(this.props, nextProps) && equals(this.state, nextState)) return false

    return true
  }

  getMainComponent = () => {
    switch (this.props.user.role) {
      case 'Back Office Admin':
      case 'Back Office MiAdvenio':
      case 'Back Office Talisis':
        return mainComponent.back_office
      case 'Director' :
        return mainComponent.director
      case 'Receptionist' :
      default:
        return mainComponent.default
    }
  }

  fetchDataBasedOnUserType = () => {
    const {
      getClassrooms,
      getCompanies,
      getConsumables,
      getConsumablesCategories,
      getCountries,
      getEmergencyMedications,
      getHealthCheckQuestions,
      getIncidentTypes,
      getInventoryItems,
      getMood,
      getNotificationsTypes,
      getParentPaymentTypes,
      getPaymentTypesMsi,
      getProgramLevels,
      getRelations,
      getStudyPrograms,
      user,
      getRegimenFiscal,
    } = this.props

    if (!user) {
      return null
    }

    getCountries()

    if (!stringContainsAnyOf(user.role, ['Back Office', 'Parent'])) {
      getClassrooms({'basic':true,'students':true})
      getCompanies()
      getConsumables(user.center_id)
      getConsumablesCategories()
      getEmergencyMedications()
      getHealthCheckQuestions()
      getIncidentTypes()
      getInventoryItems()
      getMood()
      getParentPaymentTypes()
      getProgramLevels()
      getStudyPrograms(user.center_id)
    }
    getPaymentTypesMsi()
    getRelations()

    if (!stringContainsAnyOf(user.role, ['Back Office'])) {
      getNotificationsTypes()
    }

    return true
  }

  render() {
    const { user } = this.props

    return (
      <Switch>
        <MainRoute exact path="/" component={this.getMainComponent()} user={user} />
        <Route exact path="/children" component={CenterRoute} />
        <Route exact path="/enrollments" component={InscriptionsRoute} />
        <Route exact path="/attendance" component={AttendanceRoute} />
        <Route exact path="/kids" component={KidsRoute} />
        <Route exact path="/finances" component={FinancesRoute} />
        <Route exact path="/incidents" component={IncidentsRoute} />
        <Route exact path="/enrollment" component={EnrollmentRoute} />
        <Route exact path="/disenrollment" component={DisenrollmentRoute} />
        <Route exact path="/masterlist" component={MasterListRoute} />
        <Route exact path="/receipt" component={ReceiptRoute} />
        <Route exact path="/unvalidated-receipts-report" component={UnvalidatedReceiptsReportRoute} />
        <Route exact path="/domiciliation-report" component={DomiciliationReportRoute} />
        <Route exact path="/ratings" component={RatingsRoute} />
        <Route exact path="/reinscriptions" component={ReinscriptionsRoute} />
        <Route exact path="/reservations" component={ReservationsRoute} />
        <Route exact path="/disenrollments" component={UnsubscribeRoute} />
        <Route exact path="/virtual-checkin" component={VirtualCheckinRoute} />
        <Route exact path="/classroom/:classId/student/:id" component={StudentProfileRoute} />
        <Route exact path="/centers/:centerId/:view" component={OverviewRoute} />
        <Route exact path="/payment-reminders" component={PaymentRemindersRoute} />
        <ParentRoute exact path="/parent" component={ParentPlatformRoute} user={user} />
        <ParentRoute exact path="/parent/balance" component={BalanceRoute} user={user} />
        <Route exact path="/medicine" component={MedicineRoute} />
        <Route exact path="/advanced-search" component={AdvancedSearchRoute} />
        <Route exact path="/unvalidated-receipts" component={UnvalidatedReceiptsRoute} />
        <Route exact path="/validated-receipts" component={ValidatedReceiptsRoute} />
        <Route exact path="/unvalidated-photos" component={UnvalidatedPhotosRoute} />
        <Route exact path="/video-generator" component={VideoGeneratorRoute} />
        <Route exact path="/videos" component={VideoListRoute} />
        <Route exact path="/reservations-b2b" component={ReservationsB2BRoute} />
        <Route exact path="/reservations-home" component={ReservationsBmxRoute} />
        <Route exact path="/reports-Bi" component={ReportsBiRoute} />
        <Route exact path="/medallia" component={MedalliaReportRoute} />
        <Route exact path="/courses-create-profile" component={CreateProfileRoute} />
        <Route exact path="/courses-info" component={CreateInfoRoute} />
        <Route exact path="/scann-qr" component={TestQrRoute} />
        <Route exact path="/occasional" component={ServiceOccasionalRoute} />
        <Route exact path="/occasional/new" component={NewServiceOccasionalRoute} />
        <Route exact path="/documents" component={DocumentLibraryRoute} />
        <Route exact path="/documents/:id" component={DocumentDetailRoute} />
        <Route render={() => <Redirect to="/" />} />
      </Switch>
    )
  }
}

AppContainer.propTypes = {
  user: PropTypes.object.isRequired,
  getConsumables: PropTypes.func.isRequired,
  getConsumablesCategories: PropTypes.func.isRequired,
  getStudyPrograms: PropTypes.func.isRequired,
  getHealthCheckQuestions: PropTypes.func.isRequired,
  getInventoryItems: PropTypes.func.isRequired,
  getCompanies: PropTypes.func.isRequired,
  getCenterOptions: PropTypes.func.isRequired,
  getParentPaymentTypes: PropTypes.func.isRequired,
  getCountries: PropTypes.func.isRequired,
  getNotificationsTypes: PropTypes.func.isRequired,

  /** Get a listing of all relations from the API */
  getRelations: PropTypes.func.isRequired,
}

const mapStateToProps = ({ auth,classrooms }) => ({
  user: auth.user,
  classrooms: classrooms.get.results,
})

const mapDispatchToProps = dispatch => ({
  getNotificationsTypes: () => dispatch(NotificationsActions.getRequest()),
  getConsumables: centerId => dispatch(ConsumbalesActions.getRequest(centerId)),
  getClassrooms: (query) => dispatch(ClassroomActions.getRequest(query,true)),
  getConsumablesCategories: () => dispatch(ConsumbalesCategoriesActions.getRequest()),
  getStudyPrograms: centerId => dispatch(StudyProgramsActions.getRequest(centerId,true)),
  getHealthCheckQuestions: () => dispatch(HealthCheckActions.getRequest()),
  getInventoryItems: () => dispatch(InventoryActions.getRequest()),
  getCompanies: () => dispatch(CompaniesActions.getRequest()),
  getRelations: () => dispatch(RelationsActions.getRequest()),
  getCenterOptions: () => dispatch(CenterOptionsActions.getRequest()),
  getParentPaymentTypes: () => dispatch(ParentPaymentTypesActions.getRequest()),
  getPaymentTypesMsi: () => dispatch(PaymentTypesMsiActions.getRequest()),
  getCountries: () => dispatch(CountriesActions.getRequest()),
  getEmergencyMedications: () => dispatch(EmergencyMedicationsActions.getRequest()),
  getMood: () => dispatch(MoodActions.getRequest()),
  getIncidentTypes: () => dispatch(IncidentTypesActions.getRequest()),
  getProgramLevels: () => dispatch(ProgramLevelsActions.getRequest()),
  getRegimenFiscal: () => dispatch(RegimenFiscalActions.getRequest()),
  getUsoCFDI: () => dispatch(UsoCFDIActions.getRequest()),
  setCheckout: (student_id, classroom_id, action) => dispatch(ClassroomActions.setCheckout(student_id, classroom_id, action)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppContainer))



// WEBPACK FOOTER //
// ./src/Containers/AppContainer.jsx